import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import MdmLink from '~/components/atoms/MdmLink.vue';
import Rebound from '~/components/molecules/Editorial/Global/Rebound.vue';
export default {
  name: 'Rebounds',
  components: {
    TitleSection: TitleSection,
    SubtitleSection: SubtitleSection,
    SimpleParagraph: SimpleParagraph,
    MdmLink: MdmLink,
    Rebound: Rebound
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _this = this;

      var _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23;

      return {
        title: ((_ref23 = this.payload) != null ? (_ref23 = _ref23.primary) != null ? (_ref23 = _ref23.title) != null ? _ref23[0] : _ref23 : _ref23 : _ref23) || {},
        titleColor: ((_ref22 = this.payload) != null ? (_ref22 = _ref22.primary) != null ? _ref22.title_color : _ref22 : _ref22) || '',
        subtitle: ((_ref21 = this.payload) != null ? (_ref21 = _ref21.primary) != null ? (_ref21 = _ref21.subtitle) != null ? _ref21[0] : _ref21 : _ref21 : _ref21) || {},
        subtitleColor: ((_ref20 = this.payload) != null ? (_ref20 = _ref20.primary) != null ? _ref20.subtitle_color : _ref20 : _ref20) || '',
        paragraph: ((_ref19 = this.payload) != null ? (_ref19 = _ref19.primary) != null ? _ref19.paragraph : _ref19 : _ref19) || [],
        readMore: ((_ref18 = this.payload) != null ? (_ref18 = _ref18.primary) != null ? _ref18.read_more : _ref18 : _ref18) === 'Yes',
        button: {
          text: ((_ref17 = this.payload) != null ? (_ref17 = _ref17.primary) != null ? _ref17.button_text : _ref17 : _ref17) || '',
          url: ((_ref16 = this.payload) != null ? (_ref16 = _ref16.primary) != null ? (_ref16 = _ref16.button_url) != null ? _ref16.url : _ref16 : _ref16 : _ref16) || '',
          tracking: {
            data: {
              event_category: ((_ref15 = this.payload) != null ? (_ref15 = _ref15.primary) != null ? _ref15.event_category : _ref15 : _ref15) || '',
              event_action: ((_ref14 = this.payload) != null ? (_ref14 = _ref14.primary) != null ? _ref14.event_action : _ref14 : _ref14) || '',
              event_label: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? _ref13.event_label : _ref13 : _ref13) || ''
            }
          }
        },
        selections: this.payload.items.map(function (i) {
          var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12;

          return {
            image: {
              small: formatPrismicImage((_ref12 = i) != null ? (_ref12 = _ref12.image) != null ? _ref12.url : _ref12 : _ref12, ['w_375']) || EMPTY_PIXEL,
              medium: formatPrismicImage((_ref11 = i) != null ? (_ref11 = _ref11.image) != null ? _ref11.url : _ref11 : _ref11, ['w_375,dpr_2']) || EMPTY_PIXEL,
              large: formatPrismicImage((_ref10 = i) != null ? (_ref10 = _ref10.image) != null ? _ref10.url : _ref10 : _ref10, ['w_1440']) || EMPTY_PIXEL,
              xlarge: formatPrismicImage((_ref9 = i) != null ? (_ref9 = _ref9.image) != null ? _ref9.url : _ref9 : _ref9, ['w_1440,dpr_2']) || EMPTY_PIXEL
            },
            title: ((_ref8 = i) != null ? _ref8.title : _ref8) || '',
            subtitle: ((_ref7 = i) != null ? _ref7.subtitle : _ref7) || '',
            withIcon: _this.withIcon(((_ref6 = i) != null ? _ref6.with_icon : _ref6) || ''),
            button: {
              text: ((_ref5 = i) != null ? _ref5.button_text : _ref5) || '',
              url: ((_ref4 = i) != null ? (_ref4 = _ref4.button_url) != null ? _ref4.url : _ref4 : _ref4) || '',
              tracking: {
                data: {
                  event_category: ((_ref3 = i) != null ? _ref3.event_category : _ref3) || '',
                  event_action: ((_ref2 = i) != null ? _ref2.event_action : _ref2) || '',
                  event_label: ((_ref = i) != null ? _ref.event_label : _ref) || ''
                }
              }
            }
          };
        })
      };
    }
  },
  methods: {
    withIcon: function withIcon(arg) {
      return arg === 'true';
    }
  }
};